import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService } from "../core/util/httpManager";
import React from "react";
export class ServiceReportListApp extends React.Component<ServiceReportListAppProps, {
    serviceReportList: any;
}> {
    common = new AppHelper();

    translations = [];
    serviceReportListGridOptions = [];
    newReportEnabled: boolean = false;

    constructor(props) {
        super(props)
        this.common.init(this);
        this.state = {
            serviceReportList: this.props.serviceReportList
        }
        this._initApp();
    }

    newReport = () => {
        if (this.props.entity.useThinfinityDgfUrl) {
            const dummyLink = $("<a>").text("thinfinity").attr({
                id: "dummyLink",
                href: Config.baseUrl + "ServiceReport/ThinfinityDgfCreate?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + encodeURIComponent(String(this.props.entity.PIndex)),
                target: "_blank"
            }).css({ display: "none" });
            $("body").append(dummyLink);
            $("#dummyLink")[0].click();
            $(dummyLink).remove();

            setTimeout(() => this.refreshData(), 10000);
        }
        else {
            const sheet = General.Sheet.Manager.createSheetWithUrl("ServiceReport/New?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + encodeURIComponent(String(this.props.entity.PIndex)), null, { disableTabTitle: true });
            sheet.setTitle(this.translations["WebSMS.ServiceReport.ServiceReport"]);
            sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
                this.refreshData();
            });
        }
    }

    openServiceReport = (belegNr) => {
        if (this.props.entity.useThinfinityDgfUrl) {
            const dummyLink = $("<a>").text("thinfinity").attr({ id: "dummyLink", href: Config.baseUrl + "ServiceReport/ThinfinityDgfOpen?belegNr=" + belegNr, target: "_blank" }).css({ display: "none" });
            $("body").append(dummyLink);
            $("#dummyLink")[0].click();
            $(dummyLink).remove();
        }
        else {
            const sheet = General.Sheet.Manager.createSheetWithUrl(`ServiceReport/Edit?id=${encodeURIComponent(belegNr)}`, null, null, true);
            sheet.setTitle(this.translations["WebSMS.ServiceReport.ServiceReport"]);
            sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
                this.refreshData();
            });
            sheet.bind(SheetEventType.ItemDeleted, this.refreshData);
        }
    }

    refreshData = () => {
        HTTPService.get("ServiceReport/InitListView/?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + encodeURIComponent(String(this.props.entity.PIndex)))
            .then(data => {
                this.setState({ serviceReportList: data.Data });
            });
    }

    onChangeServiceReportList = async (item) => {
        if (item != null) {
            if (!this.props.entity.useThinfinityDgfUrl && !Helper.hasValue(item.Ursprung)) {
                if (!(await DialogHelper.confirm(this.translations["WebSMS.ServiceReport.AndererUrsprungAlsWebSMS"]))) {
                    return;
                }
            }
            this.openServiceReport(item.Belegnr);
        }
    }

    onRefresh = () => {
        this.refreshData();
    }

    private _initApp = () => {
        this.setContext();

        this.newReportEnabled = this.props.serviceReportList.CreateServiceReportRights.CanCreateNewServiceReports
    }

    private setContext = () => {
        this.props.context.serviceReportList = this.state.serviceReportList;
        this.props.context.serviceReportListGridOptions = this.serviceReportListGridOptions;
        this.props.context.onChangeServiceReportList = this.onChangeServiceReportList;
        this.props.context.onRefresh = this.onRefresh;
    }

    componentDidMount() {
        if (Helper.hasValue(this.props.entity.BelegNr)) {
            const openSR = async () => {
                if (!this.props.entity.useThinfinityDgfUrl && !Helper.hasValue(this.props.entity.Ursprung)) {
                    if (!(await DialogHelper.confirm(this.translations["WebSMS.ServiceReport.AndererUrsprungAlsWebSMS"]))) {
                        return;
                    }
                }

                this.openServiceReport(this.props.entity.BelegNr);
            }

            openSR();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        this.setContext();

        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp dc4ModuleName="app/serviceReportList/serviceReportListStates" {...props} />;
    }
};

export interface EntityServiceReportList extends Entity {
    ProjNr: string;
    PIndex: number;
    BelegNr: number;
    Ursprung: string;
    useThinfinityDgfUrl: boolean;
}

interface ContextServiceReportList extends Context {
    serviceReportList: {
        RecordRightEinsatz: {
        }
        CreateServiceReportRights: {
            CanCreateNewServiceReports: boolean
        }
    }
    serviceReportListGridOptions: any;
    onChangeServiceReportList(item: any, readonly: boolean);
    onRefresh: any;
}

export interface ServiceReportListAppProps extends AppBaseProps {
    entity: EntityServiceReportList;
    context: ContextServiceReportList;
    serviceReportList: {
        RecordRightEinsatz: {

        }
        CreateServiceReportRights: {
            CanCreateNewServiceReports: boolean
        }
    }
}